import { Link } from 'react-router-dom';
import { getFeaturedPosts } from '@/mocks/posts';

export default function FeaturedPosts() {
  const featuredPosts = getFeaturedPosts();

  return (
    <div className="space-y-5">
      {featuredPosts.map((post) => (
        <Link
          key={post.id}
          to={`/article/${post.slug}`}
          className="group block bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/70 transition-all duration-300 cursor-pointer"
        >
          <div className="flex flex-col sm:flex-row">
            <div className="w-full sm:w-48 h-40 sm:h-full flex-shrink-0 overflow-hidden">
              <img
                src={post.coverImage}
                alt={post.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4 md:p-5 flex flex-col justify-center flex-1 min-w-0">
              <div className="flex items-center gap-3 mb-2">
                <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 font-medium">
                  {post.category}
                </span>
                <span className="text-xs text-foreground-400">
                  {post.publishDate}
                </span>
              </div>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                {post.title}
              </h3>
              <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                {post.excerpt}
              </p>
              <div className="flex items-center gap-4 mt-3 text-xs text-foreground-400">
                <span className="flex items-center gap-1">
                  <i className="ri-heart-line w-3 h-3 flex items-center justify-center"></i>
                  {post.likes.toLocaleString()}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-chat-1-line w-3 h-3 flex items-center justify-center"></i>
                  {post.comments.toLocaleString()}
                </span>
                <span>{post.readTime} 分钟阅读</span>
              </div>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}